import { Mail, MapPin, Phone } from "lucide-react";
import { PROFILE } from "../data/content";

const FB_SVG = (size = 18) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 12.073C24 5.404 18.627 0 12 0S0 5.404 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97h-1.513c-1.491 0-1.956.93-1.956 1.886v2.267h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
  </svg>
);

function InfoRow({ icon, label, value, href }) {
  const content = (
    <div style={{
      display: "flex", alignItems: "center", gap: 14,
      padding: "16px 0",
      borderBottom: "1px solid #F1F5F9",
      transition: "opacity 150ms",
      cursor: href ? "pointer" : "default",
    }}
      onMouseEnter={e => { if (href) e.currentTarget.style.opacity = "0.7"; }}
      onMouseLeave={e => { e.currentTarget.style.opacity = "1"; }}
    >
      <div style={{
        width: 36, height: 36, borderRadius: 9,
        background: "#EFF6FF",
        display: "flex", alignItems: "center", justifyContent: "center",
        flexShrink: 0, color: "#2563EB",
      }}>
        {icon}
      </div>
      <div>
        <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 10, fontWeight: 600, color: "#94A3B8", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 1 }}>
          {label}
        </div>
        <div style={{ fontFamily: "'Archivo',sans-serif", fontWeight: 700, fontSize: 14, color: "#09090B" }}>
          {value}
        </div>
      </div>
    </div>
  );

  if (href) {
    return (
      <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel={href.startsWith("http") ? "noopener noreferrer" : undefined} style={{ textDecoration: "none", display: "block" }}>
        {content}
      </a>
    );
  }
  return content;
}

export default function Contact() {
  return (
    <div style={{ maxWidth: 1100, margin: "0 auto", padding: "72px 24px 100px" }}>

      <div className="reveal" style={{ marginBottom: 16 }}>
        <span className="section-label">Liên hệ</span>
      </div>

      {/* Bento Grid: left hero + right info card */}
      <div className="reveal reveal-delay-1 contact-grid">

        {/* Left: Hero dark card */}
        <div className="contact-hero-card">
          <div>
            <div style={{
              fontFamily: "'Space Grotesk',sans-serif",
              fontSize: 11, fontWeight: 700,
              color: "#2563EB",
              textTransform: "uppercase", letterSpacing: "0.1em",
              marginBottom: 20,
            }}>
              Liên hệ
            </div>
            <h2 style={{
              fontFamily: "'Archivo',sans-serif",
              fontWeight: 900, fontSize: "clamp(28px,3vw,44px)",
              color: "#fff",
              margin: "0 0 16px",
              letterSpacing: "-0.03em",
              lineHeight: 1.08,
            }}>
              Nói chuyện<br />với mình.
            </h2>
            <p style={{
              fontFamily: "'Space Grotesk',sans-serif",
              fontSize: 14, color: "#94A3B8",
              lineHeight: 1.7, margin: 0,
              maxWidth: 280,
            }}>
              Hợp tác, góp ý, hay chỉ muốn hỏi thăm. Mình đọc mọi tin nhắn.
            </p>
          </div>

        </div>

        {/* Right: Info card — same height as hero */}
        <div className="contact-info-card">
          <div style={{
            fontFamily: "'Archivo',sans-serif",
            fontWeight: 800, fontSize: 16,
            color: "#09090B",
            marginBottom: 4,
          }}>
            Tìm mình ở đây
          </div>
          <div style={{
            fontFamily: "'Space Grotesk',sans-serif",
            fontSize: 13, color: "#94A3B8",
            marginBottom: 8,
          }}>
            Phản hồi trong vòng 24 giờ.
          </div>

          <div>
            <InfoRow
              icon={<Phone size={17} />}
              label="Điện thoại"
              value={PROFILE.phone}
              href={`tel:${PROFILE.phone?.replace(/\s/g, "")}`}
            />
            <InfoRow
              icon={<Mail size={17} />}
              label="Email"
              value={PROFILE.email}
              href={`mailto:${PROFILE.email}`}
            />
            <InfoRow
              icon={<MapPin size={17} />}
              label="Địa điểm"
              value={PROFILE.location}
              href={null}
            />
            <div style={{ borderBottom: "none" }}>
              <InfoRow
                icon={<span style={{ color: "#2563EB", display: "flex" }}>{FB_SVG(17)}</span>}
                label="Facebook"
                value="facebook.com/anhduy.pharma"
                href="https://facebook.com/anhduy.pharma"
              />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
